import { MaybeRef } from '@vueuse/core'
import { computed, ref, unref } from 'vue'
import { SDS_CANONICAL_PREFIX, TDS_CANONICAL_PREFIX } from '@/composables/useItemNamesFromLocalesFile'

// Don't forget send in all the options the name translated with 'name: t(item.name)' and value should be the same name without translate 'value: item.name'
export default function useTreeItemsSection(allItemsOptions: MaybeRef<Array<{ name: string; value: string }>>) {
  const search = ref('')
  const searchArray = ref<string[]>([])

  const itemOptionsFiltered = computed(() => {
    if (search.value) {
      if (search.value.length > 2) {
        return unref(allItemsOptions)
          .filter((item) => {
            return (
              item.name.toLocaleLowerCase().includes(search.value.toLocaleLowerCase()) || // Search by translated name
              item.value.toLocaleLowerCase().includes(search.value.toLocaleLowerCase()) // Search by canonical name
            ) // Apply lowercase to both strings to make the search insensitive
          })
          .map((i) => {
            return { name: i.name, value: i.value }
          })
      } else {
        return unref(allItemsOptions)
      }
    } else {
      if (searchArray.value.length > 0) {
        return unref(allItemsOptions).filter((item) => searchArray.value.some((searchItem) => item.value == searchItem))
      } else {
        return unref(allItemsOptions)
      }
    }
  })

  function getPassportItemsBySection(sectionId: string) {
    const exactItems = getPassportExactSectionItems(sectionId)

    const subSectionItems = getPassportSubSectionItems(sectionId)
    return [...exactItems, ...subSectionItems]
  }

  function getPassportExactSectionItems(sectionId: string) {
    return itemOptionsFiltered.value.filter(
      (item) => item.value === sectionId || item.value.split('.')[0] === sectionId
    )
  }

  function getPassportSubSectionItems(sectionId: string) {
    return itemOptionsFiltered.value.filter((item) => item.value.startsWith(`${sectionId}_`))
  }

  function getPassportExactSubSectionItems(sectionId: string) {
    return itemOptionsFiltered.value.filter((item) => item.value.startsWith(sectionId))
  }

  function getPassportExtraItems() {
    return itemOptionsFiltered.value.filter(
      (item) => !item.value.startsWith(SDS_CANONICAL_PREFIX) && !item.value.startsWith(TDS_CANONICAL_PREFIX)
    )
  }

  return {
    getPassportItemsBySection,
    getPassportExtraItems,
    getPassportExactSubSectionItems,
    getPassportExactSectionItems,
    search,
    searchArray,
  }
}
